import ChoseGamePage from './ChoseGame'

export default ChoseGamePage